import axios from 'axios'
import SessionStorage from 'sessionstorage';
import _ from 'underscore'
import {APIHOST, MOMENT_API_DATE_FORMAT, MOMENT_API_DATE_TIME_FORMAT} from "@/settings";
import {jsonDataToExcel} from "@/js/XLSX";
import mappers from "@/helpers/mappers";

class OrderService {
    getAllBox({
                  sortBy,
                  sortDesc,
                  skip,
                  limit,
                  search,
                  startExpireOn,
                  endExpireOn,
                  startCreatedOn,
                  endCreatedOn,
                  branch,
                  isExecutorApproved,
                  isCustomerApproved,
                  isDeclined,
                  isStopped,
                  status,
                  statuses
              }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/OrderAllbox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search,
                startExpireOn: startExpireOn ? startExpireOn.format(MOMENT_API_DATE_FORMAT) : null,
                endExpireOn: endExpireOn ? endExpireOn.format(MOMENT_API_DATE_FORMAT) : null,
                startCreatedOn: startCreatedOn ? startCreatedOn.format(MOMENT_API_DATE_TIME_FORMAT) : null,
                endCreatedOn: endCreatedOn ? endCreatedOn.format(MOMENT_API_DATE_TIME_FORMAT) : null,
                branch: branch ? branch : null,
                isExecutorApproved: typeof (isExecutorApproved) === 'boolean' ? isExecutorApproved : null,
                isCustomerApproved: typeof (isCustomerApproved) === 'boolean' ? isCustomerApproved : null,
                isDeclined: typeof (isDeclined) === 'boolean' ? isDeclined : null,
                isStopped: typeof (isStopped) === 'boolean' ? isStopped : null,
                status: typeof (status) === 'number' ? status : null,
                statuses:statuses
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getInfo(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/OrderInfo/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    create(data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.post(`${APIHOST}/api/RegisterOrder`, data, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        })
    }

    edit(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.put(`${APIHOST}/api/RegisterOrder`, data, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {
                id: id
            }
        })
    }

    approve(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/ApproveOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    decline(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/DeclineOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    cancelDecline(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/CancelDeclineOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    stopOrder(id,data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/StopOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    resumeOrder(id,data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/ResumeOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    orderProtocol(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/OrderProtocolInfo/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    downloadExcelSingle(id) {
        return new Promise((resolve, reject) => {
            this.getInfo(id)
                .then(response => {
                    const orderInfo = mappers.mapOrderInfo(response.data)
                    const column1 = 'Магазин'
                    const column2 = 'Номер'
                    const column3 = 'Дата'
                    const column4 = 'Номер договора'
                    const column5 = 'Дата договора'
                    const column6 = 'Поставщик'
                    const column7 = 'Заказчик'

                    const column8 = 'Подтверждён поставщиком'
                    const column9 = 'Подтверждён заказчиком'
                    const column10 = 'Приостановлен поставщиком'
                    const column11 = 'Отказано поставщиком'
                    const column12 = 'Дата создания'

                    let excelData = []

                    let orderMetaRow = {}
                    orderMetaRow[column1] = orderInfo.deliveryAddress
                    orderMetaRow[column2] = orderInfo.number
                    orderMetaRow[column3] = orderInfo.date.format('DD.MM.YYYY');
                    orderMetaRow[column4] = orderInfo.contractNumber;
                    orderMetaRow[column5] = orderInfo.contractDate.format('DD.MM.YYYY')
                    orderMetaRow[column6] = orderInfo.executorName
                    orderMetaRow[column7] = orderInfo.customerName
                    orderMetaRow[column8] = orderInfo.isExecutorApproved ? 'Да' : 'Нет'
                    orderMetaRow[column9] = orderInfo.isCustomerApproved ? 'Да' : 'Нет'
                    orderMetaRow[column10] = orderInfo.isStopped ? 'Да' : 'Нет'
                    orderMetaRow[column11] = orderInfo.isExecutorDeclined ? 'Да' : 'Нет'
                    orderMetaRow[column12] = orderInfo.createdOn.format('DD.MM.YYYY HH:mm:ss')
                    excelData.push(orderMetaRow)

                    // empty roworder
                    excelData.push({})

                    let itemsHeaderRow = {}
                    itemsHeaderRow[column1] = '№'
                    itemsHeaderRow[column2] = 'Товар'
                    itemsHeaderRow[column3] = 'Штрих-код'
                    itemsHeaderRow[column4] = 'Ед.изм'
                    itemsHeaderRow[column5] = 'Количество'
                    itemsHeaderRow[column6] = 'Цена за единицу'
                    itemsHeaderRow[column7] = 'Стоимость'
                    itemsHeaderRow[column8] = 'НДС ставка'
                    itemsHeaderRow[column9] = 'НДС сумма'
                    itemsHeaderRow[column10] = 'Сумма с НДС'
                    excelData.push(itemsHeaderRow)


                    _.each(orderInfo.items, (orderItem, index) => {
                        let itemRow = {}
                        itemRow[column1] = ` ${index + 1}`
                        itemRow[column2] = orderItem.product
                        itemRow[column3] = orderItem.customerCode
                        itemRow[column4] = orderItem.measurement
                        itemRow[column5] = orderItem.quantity
                        itemRow[column6] = orderItem.price
                        itemRow[column7] = orderItem.total
                        itemRow[column8] = orderItem.ndsRate
                        itemRow[column9] = orderItem.ndsValue
                        itemRow[column10] = orderItem.totalWithNds

                        excelData.push(itemRow)
                    })

                    jsonDataToExcel(excelData, `Заказ ${orderInfo.number} от ${orderInfo.date.format('DD-MM-YYYY')} в ${orderInfo.deliveryAddress}.xlsx`)

                    resolve()
                }, reject).bind(this)
        })
    }

    downloadExcelAllWithItems(params, onEachOrderInfoComplete) {
        this.getAllBox(params)
            .then(response => {
                const orders = _.map(response.data.Records, orderViewModel => {
                    return mappers.mapOrder(orderViewModel)
                })
                const loadOrderPromises = []
                _.each(orders, order => {
                    loadOrderPromises.push(this.getInfo(order.id).finally(() => {
                        if (typeof (onEachOrderInfoComplete) === 'function')
                            onEachOrderInfoComplete();
                    }))
                })

                Promise.all(loadOrderPromises)
                    .then(orderInfoPromiseResults => {
                        const column1 = 'Магазин'
                        const column2 = 'Номер'
                        const column3 = 'Дата'
                        const column4 = 'Номер договора'
                        const column5 = 'Дата договора'
                        const column6 = 'Поставщик'
                        const column7 = 'Заказчик'

                        const column8 = 'Подтверждён поставщиком'
                        const column9 = 'Подтверждён заказчиком'
                        const column10 = 'Приостановлен поставщиком'
                        const column11 = 'Отказано поставщиком'

                        const column12 = 'Дата создания'
                        const column13 = '№'
                        const column14 = 'Товар'
                        const column15 = 'Ед.изм'
                        const column16 = 'Количество'
                        const column17 = 'Цена за единицу'
                        const column18 = 'Стоимость'
                        const column19 = 'НДС ставка'
                        const column20 = 'НДС сумма'
                        const column21 = 'Сумма с НДС'
                        let excelData = []
                        _.each(orderInfoPromiseResults, orderInfoPromiseResult => {
                            const orderInfo = mappers.mapOrderInfo(orderInfoPromiseResult.data)

                            let index = 0;
                            _.each(orderInfo.items, item => {
                                let orderMetaRow = {}

                                orderMetaRow[column1] = orderInfo.deliveryAddress
                                orderMetaRow[column2] = orderInfo.number
                                orderMetaRow[column3] = orderInfo.date.format('DD.MM.YYYY');
                                orderMetaRow[column4] = orderInfo.contractNumber;
                                orderMetaRow[column5] = orderInfo.contractDate.format('DD.MM.YYYY')
                                orderMetaRow[column6] = orderInfo.executorName
                                orderMetaRow[column7] = orderInfo.customerName
                                orderMetaRow[column8] = orderInfo.isExecutorApproved ? 'Да' : 'Нет'
                                orderMetaRow[column9] = orderInfo.isCustomerApproved ? 'Да' : 'Нет'
                                orderMetaRow[column10] = orderInfo.isStopped ? 'Да' : 'Нет'
                                orderMetaRow[column11] = orderInfo.isExecutorDeclined ? 'Да' : 'Нет'
                                orderMetaRow[column12] = orderInfo.createdOn.format('DD.MM.YYYY HH:mm:ss')
                                orderMetaRow[column13] = `${index + 1}`
                                orderMetaRow[column14] = item.product
                                orderMetaRow[column15] = item.measurement
                                orderMetaRow[column16] = item.quantity
                                orderMetaRow[column17] = item.price
                                orderMetaRow[column18] = item.total
                                orderMetaRow[column19] = item.ndsRate
                                orderMetaRow[column20] = item.ndsValue
                                orderMetaRow[column21] = item.totalWithNds
                                index++
                                excelData.push(orderMetaRow)
                            })
                        })

                        jsonDataToExcel(excelData, `Реестр заказов.xlsx`)
                    })
            })
    }

    downloadExcelAll(params, onEachOrderInfoComplete) {
        return new Promise((resolve, reject) => {
            this.getAllBox(params)
                .then(response => {
                    let orders = _.map(response.data.Records, orderViewModel => {
                        if (typeof (onEachOrderInfoComplete) === 'function')
                            onEachOrderInfoComplete();
                        return mappers.mapOrder(orderViewModel)
                    })

                    const column1 = 'Магазин'
                    const column2 = 'Номер'

                    const column3 = 'Дата'
                    const column4 = 'Номер договора'
                    const column5 = 'Дата договора'
                    const column6 = 'Поставщик'
                    const column7 = 'Заказчик'

                    const column8 = 'Подтверждён поставщиком'
                    const column9 = 'Подтверждён заказчиком'
                    const column10 = 'Приостановлен поставщиком'
                    const column11 = 'Отказано поставщиком'
                    const column12 = 'Дата создания'
                    let excelData = []

                    _.each(orders, order => {
                        let orderMetaRow = {}
                        orderMetaRow[column1] = order.deliveryAddress
                        orderMetaRow[column2] = order.number
                        orderMetaRow[column3] = order.date.format('DD.MM.YYYY');
                        orderMetaRow[column4] = order.contractNumber;
                        orderMetaRow[column5] = order.contractDate.format('DD.MM.YYYY')
                        orderMetaRow[column6] = order.executorName
                        orderMetaRow[column7] = order.customerName
                        orderMetaRow[column8] = order.isExecutorApproved ? 'Да' : 'Нет'
                        orderMetaRow[column9] = order.isCustomerApproved ? 'Да' : 'Нет'
                        orderMetaRow[column10] = order.isStopped ? 'Да' : 'Нет'
                        orderMetaRow[column11] = order.isExecutorDeclined ? 'Да' : 'Нет'
                        orderMetaRow[column12] = order.createdOn.format('DD.MM.YYYY HH:mm:ss')


                        excelData.push(orderMetaRow)
                    })
                    jsonDataToExcel(excelData, `Реестр заказов.xlsx`)

                    resolve()
                }, reject)
        })
    }
}

export default new OrderService();
